<template>
  <div
    class="search-container"
    :class="`${focus ? 'focused ' : 'nfocused '}${customStyle}`"
    :style="'height:' + height + '; width:' + width + ';'"
  >
    <label for="searchinput">
      <feather class="search-icon" type="search" size="16" />
    </label>
    <input
      id="searchinput"
      v-model="searchtext"
      v-debounce:1000="sendData"
      type="search"
      class="search-input"
      placeholder="Pesquisar..."
      @focus="focusinput(true)"
      @blur="focusinput(false)"
    >
  </div>
</template>

<script>
export default {
	name: 'Search',
	props: {
		width: {
			type: String,
			default: '50px',
		},
		height: {
			type: String,
			default: '30px',
		},
		borderRadius: {
			type: String,
			default: '3px',
		},
		customStyle: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			focus: false,
			searchtext: '',
		};
	},
	methods: {
		focusinput(focus) {
			this.focus = focus;
		},
		styles() {},
		sendData() {
			this.$emit('searchtext', this.searchtext.toUpperCase());
		},
	},
};
</script>

<style scoped>
.focused {
	background-color: #fff;
	border: 1px solid #786dce3a;
}
.nfocused {
	background-color: #fff;
}
.search-container {
	display: flex;
	align-items: center;
	padding: 5px;
	transition: 0.3s ease-in;
}
.search-container label {
	all: unset;
	margin: 0;
	display: flex;
	padding: 5px;
}
.search-input {
	all: unset;
	width: 100%;
	height: 100%;
}

.search-input::placeholder {
	font-size: 13px;
}

.search-icon {
	color: #8b83ba;
	padding: 5px;
}
</style>
